import React from 'react';
import { FormattedMessage } from 'react-intl';
import { KebapMenu, MenuItem } from '@/ui/KebapMenu/KebapMenu';
import { T } from '@/ui/Text/Text';
import { IconArrowDown, IconArrowUp, IconTrash } from '../../../../icons';

type Props = {
  handleMoveUp: () => void;
  handleMoveDown: () => void;
  handleDeleteGroup: () => void;
  isLastGroup: boolean;
  isFirstGroup: boolean;
  isAdmin: boolean;
  disallowSlideDeletion: boolean;
};

const SlideGroupKebapMenu = ({
  handleMoveUp,
  handleMoveDown,
  handleDeleteGroup,
  isLastGroup,
  isFirstGroup,
  isAdmin,
  disallowSlideDeletion,
}: Props) => {
  return (
    <KebapMenu>
      <MenuItem
        disabled={isFirstGroup}
        onClick={() => {
          if (!isFirstGroup) {
            handleMoveUp();
          }
        }}
        icon={<IconArrowUp />}
      >
        <T body1>
          <FormattedMessage defaultMessage="Move Up" id="5p5CJU" />
        </T>
      </MenuItem>
      <MenuItem
        disabled={isLastGroup}
        onClick={() => {
          if (!isLastGroup) {
            handleMoveDown();
          }
        }}
        icon={<IconArrowDown />}
      >
        <T body1>
          <FormattedMessage defaultMessage="Move Down" id="ndFwsD" />
        </T>
      </MenuItem>
      {(isAdmin || !disallowSlideDeletion) && (
        <MenuItem
          onClick={() => {
            handleDeleteGroup();
          }}
          icon={<IconTrash />}
        >
          <T body1>
            <FormattedMessage defaultMessage="Delete" id="K3r6DQ" />
          </T>
        </MenuItem>
      )}
    </KebapMenu>
  );
};

export default SlideGroupKebapMenu;
